/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  function replaceStars() {
    const cartInfoElements = document.querySelectorAll(".cart-bar__info");
    cartInfoElements.forEach(cartInfoElement => {
      const starElement = cartInfoElement.querySelector(".jdgm-prev-badge__stars");
      if (starElement) {
        starElement.innerHTML = "★";
      }
    });
  }
  
  replaceStars();
  


  // Scroll event listener

  function checkScrollPosition() {
    // If below the fold, add a class to the body
    if (window.scrollY > window.innerHeight) {
      document.body.classList.add('below-the-fold');
    } else {
      document.body.classList.remove('below-the-fold');
    }
  }

  window.addEventListener('scroll', checkScrollPosition);

    document.querySelector(".jdgm-prev-badge__stars").innerHTML = "★";
})();